export default {
  SET_LISTS(state, lists) {
    state.lists = lists
    state.lastUpdate = parseInt((new Date().getTime() / 1000));
  },
}
